import {
  Box,
  Button,
  Divider,
  Flex,
  Text,
} from '@chakra-ui/react';
import MuiIcon from 'components/MuiIcon';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useGetOneService, useGet3thPartyServices } from 'shared/api/requests/services';
import Card from 'shared/components/horizon-ui/card/Card';
import Link from 'shared/components/Link';
import Loader from 'shared/components/Loader';
import MainModelInfo from 'shared/components/MainModelInfo';
import useGetColors from 'shared/hooks/useGetColors';
import { PathsE, PathsParams } from 'shared/routes';
import ModelInfo from './ModelInfo';
import PageTitle from 'shared/views/admin/PageTitle';

const Show = () => {
  const { t } = useTranslation();
  const { actorId, serviceId } = useParams<PathsParams[PathsE.SHOW_ACTOR]>();
  const {
    gray100,
    gray500,
    gray700,
    gray800,
  } = useGetColors();
  const requestParams = {
    pathParams: { actorId, serviceId },
    params: {},
  };

  const { data: currentService } = useGetOneService({
    pathParams: { serviceId },
    params: undefined
  });

  const { useGetOneActor } = useGet3thPartyServices({
    domain: currentService?.domain,
    token: currentService?.token,
  });
  const { data, isPending } = useGetOneActor(requestParams);

  const breadcrumbs = [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
    {
      path: PathsE.ACTORS,
      text: t('services.actors'),
      pathsParams: {
        serviceId,
      },
    },
  ];

  if (isPending || !data) return <Loader />;

  return (
    <Box>
      <PageTitle
        title={data.name}
        breadcrumbs={breadcrumbs}
        backUrl={{ path: PathsE.ACTORS, pathsParams: { serviceId } }}
      />
      <Card mb="20px" borderRadius="20px" px="30px">
        <Flex justifyContent="space-between" alignItems="center" mt="-10px">
          <Text color={gray700} fontWeight="600">
            {data.name}
          </Text>
          <Flex alignItems="center">
            <Box mr="10px">
              <Link<PathsParams[PathsE.UPDATE_ACTOR]>
                path={PathsE.UPDATE_ACTOR}
                pathsParams={{ actorId, serviceId }}
              >
                <Button
                  color={gray800}
                  bgColor={gray100}
                  borderRadius="8px"
                  leftIcon={<MuiIcon name="edit" />}
                >
                  {t('services.editActor')}
                </Button>
              </Link>
            </Box>
          </Flex>
        </Flex>
        <MainModelInfo data={data} />
        <ModelInfo data={data} />
        <Divider my="20px" />
        <Text
          color={gray500}
          fontSize="12px"
          mb="2px"
          fontWeight="600"
          textTransform="uppercase"
        >
          prompt
        </Text>
        <Text dangerouslySetInnerHTML={{ __html: data.prompt }}></Text>
      </Card>
    </Box>
  );
};

export default Show;
